import './globals-view/globals-view.component';
import './globals-view/globals-view.scss';

import './organization-details/organization-details.component';
import './organization-details/organization-details.scss';

import './organization-overview/organization-overview.component';
import './organization-overview/organization-overview.scss';

import './organization-sites/organization-sites.component';
import './organization-sites/organization-sites.scss';

import './organizations-details/organizations-details.component';
import './organizations-details/organizations-details.scss';

import './organizations-list-view/organizations-list-view.component';
import './organizations-list-view/organizations-list-view.scss';

import './organizations-overview/organizations-overview.component';
import './organizations-overview/organizations-overview.scss';

import './organizations-table/organizations-table.component';
import './organizations-table/organizations-table.scss';

import './organizations-table-row/organizations-table-row.component';
import './organizations-table-row/organizations-table-row.scss';

import './site-overview/site-overview.component';
import './site-overview/site-overview.scss';

import './sites-lean-table/sites-lean-table.component';
import './sites-lean-table/sites-lean-table.scss';

import './sites-lean-table-row/sites-lean-table-row.component';
import './sites-lean-table-row/sites-lean-table-row.scss';

import './sites-table/sites-table.component';
import './sites-table/sites-table.scss';

import './sites-table-row/sites-table-row.component';
import './sites-table-row/sites-table-row.scss';
